import React, { Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import StyledButton from "./StyledButton";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import Paper from "@material-ui/core/Paper";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import PasswordField from "material-ui-password-field";
import { Link } from "@reach/router";
import logo from "./../../assets/images/logo.jpg";

import {
  LOGIN_BUTTON,
  EMAIL_LABEL,
  PASSWORD_LABEL,
  RESET_PASSWORD_LABEL
} from "../../constants/labels";

import {
  userSignIn,
  userForgotPassword
} from "./../../redux/actions/authActions";

const styles = (theme) => ({
  image: {
    width: "20vh",
    paddingBottom: 16
  },
  layout: {
    width: "auto",
    display: "block", // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE11 issue.
    marginTop: theme.spacing.unit
  },
  submit: {
    marginTop: theme.spacing.unit * 3
  },
  link: {
    marginTop: theme.spacing.unit * 2
  }
});

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: ""
    };
  }

  setValue = ({ name, value }) => {
    this.setState({ [name]: value.trim() });
  };

  onChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setValue({ name, value });
  };

  onSubmit = (event) => {
    event.preventDefault();
    this.props.actions.userSignIn(this.state);
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <img className={classes.image} src={logo} alt="Logo" />
            <Typography variant="subheading">Sign In</Typography>
            <form className={classes.form}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="email">{EMAIL_LABEL}</InputLabel>
                <Input
                  id="email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  onChange={this.onChange}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">{PASSWORD_LABEL}</InputLabel>
                <PasswordField
                  name="password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  onChange={this.onChange}
                />
              </FormControl>
              <StyledButton
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                onClick={this.onSubmit}
                className={classes.submit}
              >
                {LOGIN_BUTTON}
              </StyledButton>
            </form>
            <Link to="/resetPassword" className={classes.link}>
              {RESET_PASSWORD_LABEL}
            </Link>
          </Paper>
        </main>
      </Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ userSignIn, userForgotPassword }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(withStyles(styles)(Login));



// WEBPACK FOOTER //
// ./src/components/common/Login.js